module.exports = __webpack_public_path__ + "media/assets/services_manager/home-24647b67abf6166d50f0e62d334c63fcdee1edee763ca2f5dee9196fee887584.svg";